import React from 'react';
import dayjs from 'dayjs';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import type { BeraResultInformations } from '@/types/Bera';

import { Line } from './Line';
import { BlockTitle } from '../styles';
import { InfoColumns } from './styles';

const BLOCK_GUTTER = 32;
const LINE_GUTTER = 8;
const COLUMN_GUTTER = 40;
const DATE_FORMAT = 'DD/MM/YYYY';
const EMPTY_VALUE = '-';
const FULL_SPAN = 24;
const HALF_SPAN = 12;

interface DetailsProps {
	informations: BeraResultInformations;
}

function toCollectionDate(collectionDate?: Date | string): string {
	if (!collectionDate) {
		return EMPTY_VALUE;
	}

	if (typeof collectionDate === 'string') {
		return collectionDate;
	}

	const result = dayjs(collectionDate).format(DATE_FORMAT);

	return result;
}

export function Details({ informations }: Readonly<DetailsProps>): JSX.Element {
	const collectionDate = toCollectionDate(informations.collection_date);

	return (
		<Row gutter={[0, BLOCK_GUTTER]}>
			<Col span={FULL_SPAN}>
				<BlockTitle>{I18n.get('Informations')}</BlockTitle>
			</Col>
			<Col span={FULL_SPAN}>
				<InfoColumns>
					<Row gutter={[COLUMN_GUTTER, LINE_GUTTER]}>
						<Col span={HALF_SPAN}>
							<Row gutter={[0, LINE_GUTTER]}>
								<Col span={FULL_SPAN}>
									<Line label={I18n.get('Company')} value={informations.organization_name} />
								</Col>
								<Col span={FULL_SPAN}>
									<Line label={I18n.get('Unit')} value={informations.company_name} />
								</Col>
								<Col span={FULL_SPAN}>
									<Line label={I18n.get('Sector')} value={informations.sector_name} />
								</Col>
								<Col span={FULL_SPAN}>
									<Line label={I18n.get('Line')} value={informations.line_name} />
								</Col>
								<Col span={FULL_SPAN}>
									<Line label={I18n.get('Workstation')} value={informations.workstation_name} />
								</Col>
							</Row>
						</Col>
						<Col span={HALF_SPAN}>
							<Row gutter={[0, LINE_GUTTER]}>
								<Col span={FULL_SPAN}>
									<Line label={I18n.get('Cycle')} value={informations.cycle_name} />
								</Col>
								<Col span={FULL_SPAN}>
									<Line label={I18n.get('Evaluator')} value={informations.evaluator} />
								</Col>
								<Col span={FULL_SPAN}>
									<Line label={I18n.get('Work center')} value={informations.work_center} />
								</Col>
								<Col span={FULL_SPAN}>
									<Line
										label={I18n.get('Operator evaluated')}
										value={informations.operator_evaluated}
									/>
								</Col>
								<Col span={FULL_SPAN}>
									<Line label={I18n.get('Collection date')} value={collectionDate} />
								</Col>
							</Row>
						</Col>
					</Row>
				</InfoColumns>
			</Col>
		</Row>
	);
}
